import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { environment as ENV } from 'src/environments/environment';

@Component({
  selector: 'upsc-docusign-confirmation',
  templateUrl: './docusign-confirmation.component.html',
  styleUrls: ['./docusign-confirmation.component.scss']
})
export class DocusignConfirmationComponent {
  countdown: number = 5; 
  isCompleted = false;
  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {
    // Use this example in Production
    //window.opener?.postMessage({ type: 'signing-complete' }, `${ENV.baseUrl}`);
    this.route.queryParams.subscribe(params => {
      const event = params["event"];
       if (event === 'signing_complete') {
        window.opener?.postMessage({ type: 'signing-complete' }, `${ENV.baseUrl.web}`);
      } else {
        window.opener?.postMessage({ type: 'not-complete' }, `${ENV.baseUrl.web}`);
      }
    })
    
    const timer = setInterval(() => {
      this.countdown--;
      if (this.countdown <= 0) {
        clearInterval(timer)
        this.isCompleted = true;
        window.close(); 
      }
    }, 1000); 
  }

  closeWindow() {
    window.close()
  }
}
